<template>
  <div class="page page-map content">
    <MapEfriends :all-cubes="allCubes" :filtered-cubes="filteredCubes" ref="map">
      <button
        class="map-list-button button button--secondary button--white"
        @click.prevent="mapSidebar.toggle()"
      >
        <List class="button__icon-left" />
        {{ t('efriends.listTitle') }}
      </button>
      <CubeFilter
        class="map-filter"
        buttonClasses="button button--secondary button--white"
        :num-results="numResults"
      />
      <MapSidebar
        :is-loading="allCubes.length < 1"
        :filtered-cubes="filteredCubes"
        :num-results="numResults"
      />
    </MapEfriends>
  </div>
</template>

<script setup>
  import MapEfriends from '@/components/efriends/MapEfriends.vue'
  import MapSidebar from '@/components/efriends/MapSidebar.vue'
  import CubeFilter from '@/components/efriends/CubeFilter.vue'
  import { useMapStore } from '@/stores/useMapStore'
  import { useCubeFilter } from '@/composables/useCubeFilter.ts'
  import { computed } from 'vue'
  import { useMapSidebar } from '@/composables/useMapSidebar.ts'
  import { useStrings } from '@/composables/useStrings'

  const { t } = useStrings()
  const mapSidebar = useMapSidebar()
  const mapStore = useMapStore()
  const { showCubeInFilteredList } = useCubeFilter()

  const allCubes = computed(() => {
    return mapStore.globalCubeList.map((cube) => ({
      ...cube,
      showInFilteredList: showCubeInFilteredList(cube),
    }))
  })
  const filteredCubes = computed(() => {
    return allCubes.value.filter((cube) => cube.showInFilteredList)
  })
  const numResults = computed(() => {
    if (filteredCubes.value && filteredCubes.value.length > 0) {
      // Since the filtered cubes contain the user's cube we need to deduct that here.
      return filteredCubes.value.length - 1
    }
    return 0
  })
</script>

<style lang="scss">
.page-map {
  padding: 0 $spacer10;
}

$icon-color: $body-color;
$icon-line-width: 3px;
$icon-line-spacing: 3px;
$icon-width: 1.3em;

.icon-list {
  display: inline-block;
  width: $icon-width;
  margin-left: $spacer025;

  &__line-1,
  &__line-2,
  &__line-3 {
    content: '';
    height: $icon-line-width;
    background: $icon-color;
    display: block;
    transition: $transition-base;

    .page-map__toggle-sidebar--active & {
      background: $community;
    }
  }

  &__line-1 {
    margin-bottom: $icon-line-spacing;
  }

  &__line-2 {
    margin-bottom: $icon-line-spacing;
  }
}
</style>